import { render } from "./ConfiguracoesView.vue?vue&type=template&id=6af5968a&scoped=true"
import script from "./ConfiguracoesView.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesView.vue?vue&type=script&lang=js"

import "./ConfiguracoesView.vue?vue&type=style&index=0&id=6af5968a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af5968a"]])

export default __exports__